import forEach from 'lodash/forEach'

export function replaceTemplateVariables (template, values) {
  let result = template
  forEach(values, (value, key) => {
    result = result.replace(`{{${key}}}`, value)
  })
  return result
}
